<template>
  <div class="head-page">
    <Header :title="$t('withdrawal.title')" />
    <div class="withdrawal-box">
      <div class="account-box">
        <p @click="showPicker = true">
          {{ value }} {{ $t("withdrawal.title") }}
          <van-icon
            name="arrow-down"
            style="float: right; margin-top: 10px"
            size="20px"
          />
        </p>
        <span
          >{{ $t("assets.usenum") }}
          {{ parseFloat(usrinfo.balance).toFixed(8) }} {{ value }}</span
        >
      </div>
      <div class="withdrawal-frm">
        <van-tabs v-model="frm.withdraw_type">
          <van-tab :title="$t('bank.towallet')" name="1" v-if="safeWapConfig.address_switch == 1">
            <van-button
              style="display: none"
              class="web-btn-1"
              @click="$router.push('/bindMentionAddress')"
              >{{ $t("member.withdrawal_address") }}</van-button
            >

            <van-cell :title="$t('member.withdrawal_address')">
              <template #label>
                <van-field
                  disabled
                  v-model="usrinfo.address_list"
                  :placeholder="$t('member.withdrawal_address')"
                  :rules="[
                    {
                      required: true,
                    },
                  ]"
                />
              </template>
              <template #extra>
                <span @click="$router.push('/bindMentionAddress')"
                  >{{ $t("common.binding") }}
                  <van-icon name="arrow" />
                </span>
              </template>
            </van-cell>
          </van-tab>
          <van-tab :title="$t('bank.tobank')" name="2" v-if="safeWapConfig.bank_switch == 1">
            <van-cell>
              <template #title>
                <span @click="showPicker1 = true"
                  >{{ $t("bank.cardCode") }} <van-icon name="arrow-down"
                /></span>
              </template>
              <template #label>
                <van-field
                  disabled
                  v-model="bank"
                  :placeholder="$t('bank.cardCodeError')"
                  :rules="[
                    {
                      required: true,
                    },
                  ]"
                />
              </template>
              <template #extra>
                <span @click="$router.push('/bank')"
                  >{{ $t("common.binding") }}
                  <van-icon name="arrow" />
                </span>
              </template>
            </van-cell>
          </van-tab>
        </van-tabs>
        <van-form @submit="onSubmit">
          <van-cell :title="$t('withdrawal.frmtitle1')">
            <template #label>
              <van-field
                v-model="frm.num"
                type="number"
                name="validator"
                @input="inputNum"
                :placeholder="
                  $t('withdrawal.frmplaceholder1', {
                    min: usrinfo.txminnum,
                    max: usrinfo.txmaxnum,
                  })
                "
                :rules="[
                  {
                    validator,
                    message: $t('withdrawal.frmplaceholder1', {
                      min: usrinfo.txminnum,
                      max: usrinfo.txmaxnum,
                    }),
                  },
                ]"
              >
                <template #extra>
                  <span style="margin-right: 10px">{{ value }}</span
                  >|
                  <span style="margin-left: 10px" @click="toall()">{{
                    $t("common.all")
                  }}</span>
                </template>
              </van-field>
            </template>
          </van-cell>

          <van-cell :title="$t('withdrawal.frmtitle2')" v-if="safeWapConfig.traders_password_switch == 1">
            <template #label>
              <van-field
                v-model="frm.paypwd"
                type="password"
                :placeholder="$t('withdrawal.frmplaceholder2')"
                :rules="[
                  {
                    required: true,
                  },
                ]"
              >
              </van-field>
            </template>
          </van-cell>

          <van-cell :title="$t('withdrawal.getnum')">
            <template
              >{{ parseFloat(value1).toFixed(8) }} {{ value }}
            </template>
          </van-cell>
          <div style="margin: 16px">
            <p>
              {{ $t("withdrawal.fee") }}
              {{
                usrinfo.sxftype == 1
                  ? usrinfo.txsxf + " %"
                  : usrinfo.txsxf_n + " " + value
              }}
            </p>
          </div>

          <div style="margin: 16px">
            <van-button class="web-btn" native-type="submit" v-if="safeWapConfig.withdrawal_status == 1"
              ><van-loading v-if="posting" /><span v-else>{{
                $t("withdrawal.btn")
              }}</span></van-button
            >
          </div>
        </van-form>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        value-key="label"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showPicker1" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="columns1"
        @confirm="onConfirm1"
        value-key="label"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @cancel="showPicker1 = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "WithdrawalView",
  components: { Header },
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
  data() {
    return {
      usrsetting: null,
      value: null,
      showPicker: false,
      showPicker1: false,
      columns: [],
      columns1: [],
      posting: false,
      usrinfo: {},
      value1: 0,
      bank: null,
      frm: {
        c_id: null,
        num: null,
        type: 1,
        paypwd: null,
        bank_id: null,
        withdraw_type: 1,
      },
    };
  },
  mounted() {
    this.frm.withdraw_type = this.safeWapConfig.address_switch == 1 ? 1 : this.safeWapConfig.bank_switch == 1 ? 2 : 1
    this.getAddress();
    this.getUsrBankData();
  },
  methods: {
    validator(val) {
      return (
        parseFloat(val) >= parseFloat(this.usrinfo.txminnum) &&
        parseFloat(val) <= parseFloat(this.usrinfo.txmaxnum)
      );
    },
    inputNum(val) {
      let tmp = 0;
      if (this.usrinfo.sxftype == 1) {
        tmp =
          parseFloat(val) -
          (parseFloat(val) * parseFloat(this.usrinfo.txsxf)) / 100;
      } else {
        tmp = parseFloat(val) - parseFloat(this.usrinfo.txsxf_n);
      }
      if (isNaN(tmp)) tmp = 0
      if (tmp < 0) tmp = 0;
      this.value1 = tmp;
    },
    async onSubmit() {
      if (this.posting) {
        return;
      }
      this.posting = true;
      await this.$http({
        method: "post",
        url: "withdraw",
        data: this.frm,
      })
        .then((res) => {
          this.posting = false;
          this.$toast.success(res.msg);
          this.frm.num = null;
          this.frm.paypwd = null;
          this.getUserCoinBalance();
          this.aferSub()
        })
        .catch(() => {
          this.posting = false;
        });
    },
    aferSub(){
      const tpy = this.safeWapConfig.withdrawal_subover_refre
      if(tpy == 1){
        //首页
        this.$router.push({ name: "home" });
      } else if(tpy == 2) {
        // 上一页 assets
        this.$router.back();
      } 
    },
    toall() {
      this.frm.num = this.usrinfo.balance;
      this.inputNum(this.frm.num)
    },
    onConfirm(val) {
      this.value = val.label;
      this.frm.c_id = val.value;
      this.showPicker = false;
      this.frm.num = null;
      this.getUserCoinBalance();
    },
    async getAddress() {
      await this.$http({
        method: "get",
        url: "getCanWithdrawCoin",
      }).then((res) => {
        this.idata = res.data.list;
        this.columns = [];
        let tmpitem = {};
        res.data.list.forEach((item) => {
          if (this.frm.c_id && this.frm.c_id == item.id) {
            tmpitem = { value: item.id, label: item.title };
          }
          this.columns.push({ value: item.id, label: item.title });
        });
        if (!this.frm.c_id) {
          tmpitem = this.columns[0];
        }
        if (tmpitem) this.onConfirm(tmpitem);
      });
    },
    async getUsrAddress() {
      await this.$http({
        method: "get",
        url: "getusraddress",
      }).then((res) => {
        this.usrsetting = res.data;
        this.getAddress();
      });
    },
    async getUserCoinBalance() {
      this.balance = null;
      await this.$http({
        method: "post",
        url: "getUserCoinBalance",
        data: this.frm,
      }).then((res) => {
        this.usrinfo = res.data;
      });
    },
    async getUsrBankData() {
      await this.$http({
        method: "post",
        url: "getUserBankList",
      }).then((res) => {
        if (res && res.data) {
          this.columns1 = [];
          res.data.forEach((item) => {
            this.columns1.push({
              value: item.id,
              label: item.bank_name + "|" + item.card_number,
            });
          });
          if (this.columns1 && this.columns1.length > 0) this.onConfirm1(this.columns1[0]);
        }
      });
    },
    onConfirm1(val) {
      this.frm.bank_id = val.value
      this.bank = val.label.split("|")[1];
      this.showPicker1 = false;
      this.frm.num = null;
    },
  },
};
</script>

<style>
</style>
